import { Sparkle } from "lucide-react";
import "./Marquee.css";

const ITEMS = [
    "Projection Mapping",
    "Simulators",
    "Interactive Exhibits",
    "AR / VR / MR / XR",
    "Defense Training",
    "Virtual Production",
    "IntelliTrack",
    "Indigenous Hardware"
];

export const Marquee = () => {
    return (
        <section
            data-testid="capability-marquee"
            className="marquee-section border-top border-bottom py-4 overflow-hidden"
        >
            <div className="d-flex marquee-content text-nowrap gap-5">
                {[...ITEMS, ...ITEMS].map((it, i) => (
                    <div key={i} className="d-flex align-items-center gap-5">
                        <span className="font-heading marquee-text">
                            {it}
                        </span>
                        <i class="bi bi-stars fs-2" style={{ color: "#40e0d0" }}></i>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Marquee;
